/// Action creators


// Log in user
export function logInUser(user) {
  return {
    type: "logInUser",
    user: user
    }
}

export function toSignUp(user) {
  return {
  type: "USERS_REDIRECT_SIGNUP",
  user: user,
}
}


export function dispatchUser(user) {
  return {
  type: "dispatchUser",
  user: user
}
}
